import React, { useEffect, useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { connect } from "react-redux";
import { deleteVideo, getVideoFolders, getVideos, updateFolderId } from "./redux/videoEmailAction";
import LinkFile from "./LinkFile";
import EmptyStateMessageWithPicture from "../../GlobalContactDetailsForDeal/LeftSide/common/EmptyStateMessageWithPicture";


var updateWidth = 900;
const VideoLibraryModal = props => {
    let noVideos = [];
    const [folders, setFolders] = useState(props.videoFolders);
    const [videos, setVideos] = useState(props.videos);
    const [videoLoader, setVideoLoader] = useState(props.videoLoader);
    const [folderId, setFolderId] = useState(props.folderId);

    useEffect(()=>{
        let globalModalWrapperWidth = document.querySelector('.globalModalWrapper').offsetWidth;
        updateWidth = globalModalWrapperWidth;
    },[])

    useEffect(() => {
        setFolderId(props.folderId);
        props.getVideos({folderId: props.folderId});
    }, [props.folderId]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setVideoLoader(props.videoLoader);
    }, [props.videoLoader]);

    useEffect(() => {
        if (props.videoFolders === null) {
            props.getVideoFolders();
        } else {
            setFolders(props.videoFolders)
        }
    }, [props.videoFolders]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.videos === null) {
            props.getVideos({});
        } else {
            setVideos(props.videos)
        }
    }, [props.videos]); // eslint-disable-line react-hooks/exhaustive-deps

    const renderVideoFolders = () => {
        let videosFolders = [];
        if (!videoLoader) {
            if (folders !== null) {
                folders.forEach((row, index) => {
                    videosFolders.push(
                      <li onClick={(e) => props.updateFolderId(row.id)}>
                        <span>
                          <svg
                            width="87"
                            height="87"
                            viewBox="0 0 87 87"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                          >
                            <rect
                              width="87"
                              height="87"
                              fill="url(#pattern0)"
                            />
                            <defs>
                              <pattern
                                id="pattern0"
                                patternContentUnits="objectBoundingBox"
                                width="1"
                                height="1"
                              >
                                <use
                                  xlinkHref="#image0"
                                  transform="scale(0.00195312)"
                                />
                              </pattern>
                              <image
                                id="image0"
                                width="512"
                                height="512"
                                xlinkHref="data:image/png;base64,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"
                              />
                            </defs>
                          </svg>
                        </span>
                        <h6>{row.name}</h6>
                        <p>{row.email_videos_count} items</p>
                      </li>
                    );
                });
            }
        } else {
            for (let i = 0; i < 5; i++) {
                videosFolders.push(
                    <li>
                        <span>
                            <LinkFile.skeleton width={87} height={87}/>
                        </span>
                    </li>
                );
            }
        }
        return videosFolders;
    }

    const filterVideo = (e, videoId) => {
        e.target.src = `${process.env.REACT_APP_APP_URL}/assets/images/notFound.png`;
        document.getElementById('delete_video'+videoId).style.display = 'block';
        noVideos.push(videoId);
    }

    const deleteVideoFile = (e, videoId) => {
        e.preventDefault();
        e.stopPropagation();
        alert('deleteVideoFile ' + videoId);
        // MySwal.fire({
        //     title: 'Are you sure?',
        //     text: 'You will not be able to recover this data. Do you want to remove this contact?',
        //     showCancelButton: true,
        //     confirmButtonText: `Yes, Delete!`,
        // }).then((result) => {
        //     if (result.isConfirmed) {
        //         let formData = new FormData();
        //         formData.append('videoId', videoId);
        //
        //         props.deleteVideo(formData, function (response) {
        //             if (response.status) {
        //                LinkFile.Utils.showNotification(response.message, 'success');
        //             } else {
        //                 LinkFile.Utils.showNotification(response.message, 'error');
        //             }
        //         });
        //     }
        // })
    }

    const renderVideos = () => {
        let videosFiles = [];

        if (!videoLoader) {
            if (videos !== null) {
                videos.forEach((row, index) => {
                    videosFiles.push(
                        <div className="col s6 m4 l3 xl3 no-gutter">
                            <span className="d-none" id={"delete_video"+row.id} style={{cursor: 'pointer', color: '#000000'}} onClick={(e) => deleteVideoFile(e, row.id)}>
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.3418 5.2915L3.17479 13.2044C3.19216 13.3696 3.27009 13.5225 3.39355 13.6337C3.51701 13.7448 3.67725 13.8063 3.84337 13.8063H11.5958C11.7619 13.8063 11.9221 13.7448 12.0456 13.6337C12.169 13.5225 12.247 13.3696 12.2643 13.2044L13.0973 5.2915H2.3418ZM9.28807 11.3824L7.71956 9.81387L6.15105 11.3824L5.43793 10.6693L7.00645 9.10075L5.43793 7.53224L6.15105 6.81912L7.71956 8.38764L9.28807 6.81912L10.0012 7.53224L8.43267 9.10075L10.0012 10.6693L9.28807 11.3824Z"
                                            fill="white"/>
                                        <path
                                            d="M13.6593 2.1499H1.78338C1.59775 2.1499 1.44727 2.30038 1.44727 2.48601V4.05453C1.44727 4.24016 1.59775 4.39064 1.78338 4.39064H13.6593C13.8449 4.39064 13.9954 4.24016 13.9954 4.05453V2.48601C13.9954 2.30038 13.8449 2.1499 13.6593 2.1499Z"
                                            fill="white"/>
                                    </svg>
                            </span>
                            <div className="card video_thumbnails_card__alt" onClick={()=>selectLibraryVideo(row)}>
                                <div className="card-image" >
                                    <LazyLoadImage
                                        onError={(e) => filterVideo(e, row.id)}
                                        alt="Video"
                                        effect="blur"
                                        // src={notFoundImage} />
                                        src={props.s3ServerVideoUrl + '/' + row.file_name + '.gif'} />
                                    {/*<img src={props.s3ServerVideoUrl + '/' + row.file_name + '.gif'} onError={(e) => filterVideo(e, row.id)}/>*/}
                                    <div className="card_content__alt">
                                        <span className="card-title truncate"> {row.title}</span>
                                        <div className="right_icons__alt">
                                            <span className={"delete_video"+row.id} onClick={(e) => deleteVideoFile(e, row.id)}>
                                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M2.3418 5.2915L3.17479 13.2044C3.19216 13.3696 3.27009 13.5225 3.39355 13.6337C3.51701 13.7448 3.67725 13.8063 3.84337 13.8063H11.5958C11.7619 13.8063 11.9221 13.7448 12.0456 13.6337C12.169 13.5225 12.247 13.3696 12.2643 13.2044L13.0973 5.2915H2.3418ZM9.28807 11.3824L7.71956 9.81387L6.15105 11.3824L5.43793 10.6693L7.00645 9.10075L5.43793 7.53224L6.15105 6.81912L7.71956 8.38764L9.28807 6.81912L10.0012 7.53224L8.43267 9.10075L10.0012 10.6693L9.28807 11.3824Z"
                                                        fill="white"/>
                                                    <path
                                                        d="M13.6593 2.1499H1.78338C1.59775 2.1499 1.44727 2.30038 1.44727 2.48601V4.05453C1.44727 4.24016 1.59775 4.39064 1.78338 4.39064H13.6593C13.8449 4.39064 13.9954 4.24016 13.9954 4.05453V2.48601C13.9954 2.30038 13.8449 2.1499 13.6593 2.1499Z"
                                                        fill="white"/>
                                                </svg>
                                            </span>
                                            <span>
                                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0)">
                                                    <path
                                                        d="M7.23399 9.76254C8.22401 9.76254 9.02658 8.95998 9.02658 7.96996C9.02658 6.97994 8.22401 6.17737 7.23399 6.17737C6.24398 6.17737 5.44141 6.97994 5.44141 7.96996C5.44141 8.95998 6.24398 9.76254 7.23399 9.76254Z"
                                                        fill="white"/>
                                                    <path
                                                        d="M13.8122 7.48911C13.071 6.34297 12.1095 5.36937 11.0317 4.67334C9.83934 3.90253 8.52291 3.495 7.22496 3.495C6.03401 3.495 4.86294 3.83531 3.74426 4.50641C2.60344 5.19067 1.5699 6.19032 0.67221 7.47734C0.570868 7.62279 0.515056 7.79509 0.511864 7.97234C0.508672 8.14959 0.558245 8.32378 0.654284 8.47279C1.39401 9.63041 2.34604 10.6054 3.40703 11.2919C4.60162 12.0658 5.88724 12.4579 7.22496 12.4579C8.53327 12.4579 9.8525 12.0538 11.0398 11.2894C12.117 10.5956 13.0766 9.61836 13.815 8.4627C13.9077 8.31716 13.9567 8.14807 13.9562 7.97549C13.9557 7.80292 13.9057 7.63411 13.8122 7.48911ZM7.23448 10.6653C6.70267 10.6653 6.1828 10.5076 5.74062 10.2122C5.29844 9.91673 4.95379 9.49678 4.75028 9.00546C4.54676 8.51413 4.49352 7.97348 4.59727 7.45189C4.70102 6.9303 4.95711 6.45119 5.33316 6.07514C5.7092 5.69909 6.18832 5.443 6.70991 5.33925C7.2315 5.2355 7.77214 5.28875 8.26347 5.49226C8.7548 5.69578 9.17475 6.04042 9.47021 6.4826C9.76566 6.92479 9.92336 7.44465 9.92336 7.97646C9.92255 8.68935 9.639 9.3728 9.13491 9.87689C8.63082 10.381 7.94737 10.6645 7.23448 10.6653Z"
                                                        fill="white"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0">
                                                    <rect width="14.3407" height="14.3407" fill="white"
                                                          transform="translate(0.0625 0.804688)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                                {row.number_of_view}
                                            </span>
                                            <span className="d-none">
                                                <svg width="5" height="16" viewBox="0 0 5 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M2.70274 9.62495C3.69276 9.62495 4.49533 8.88411 4.49533 7.97025C4.49533 7.05638 3.69276 6.31555 2.70274 6.31555C1.71273 6.31555 0.910156 7.05638 0.910156 7.97025C0.910156 8.88411 1.71273 9.62495 2.70274 9.62495Z"
                                                        fill="white"/>
                                                    <path
                                                        d="M2.70274 15.1439C3.69276 15.1439 4.49533 14.403 4.49533 13.4892C4.49533 12.5753 3.69276 11.8345 2.70274 11.8345C1.71273 11.8345 0.910156 12.5753 0.910156 13.4892C0.910156 14.403 1.71273 15.1439 2.70274 15.1439Z"
                                                        fill="white"/>
                                                    <path
                                                        d="M2.70274 4.11408C3.69276 4.11408 4.49533 3.37325 4.49533 2.45938C4.49533 1.54552 3.69276 0.804688 2.70274 0.804688C1.71273 0.804688 0.910156 1.54552 0.910156 2.45938C0.910156 3.37325 1.71273 4.11408 2.70274 4.11408Z"
                                                        fill="white"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <span className="play_icon__alt">
                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="14.7509" cy="14.9661" r="13.9822" stroke="white" strokeWidth="0.717035"/>
                                    <path d="M11.0625 21.9078V8.00171L22.3612 14.9548L11.0625 21.9078Z" fill="white"/>
                                </svg>
                            </span>
                            </div>
                        </div>
                    );
                });
            } else {
                videosFiles.push(
                    <div className="col s12 center-align" key="no-video">
                        <EmptyStateMessageWithPicture
                        message = {"No Videos Found"}
                        />
                    </div>
                );
            }
        } else  {
            for (let i = 0; i < 8; i++) {
                videosFiles.push(
                    <div className="col s6 m6 l3 xl3 no-gutter">
                        <div className="card video_thumbnails_card">
                            <div className="card-image">
                                <LinkFile.skeleton width={175} height={200}/>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return videosFiles;
    }

    const selectLibraryVideo=(fileInfo)=>{
        props.loadSelectedVideoFile(fileInfo)
    }
    
    const getCurrentFolderName = () => {
        if (folders !== null) {
            let folderName =  folders.filter(folder => folder.id == folderId).map(folder => folder.name);
            return folderName[0];
        }
    }

    return (
        // global-large-modal
        <LinkFile.globalModal
            modalBodyClass={'awesome__scroll_bar'} 
            open={props.openVideoLibraryModal} 
            onClose={() => props.setOpenVideoLibraryModal(false)} 
            title={"Video Library"}
            className={'global-large-modal video_library_modal_wrapper__alt'}
            hideFooter={true}
        >
            <div className="video_library_wrapper__alt">
                {
                    folderId == null ?
                        <div className="video_folders__alt">
                            <ul className="d-flex justify-content-start video_library_top_folder__alt">
                                {renderVideoFolders()}
                            </ul>
                        </div> :
                        <div className="video_folders__alt">
                            <p><a href="#" onClick={(e) => {
                                e.preventDefault();
                                props.updateFolderId(null)
                            }}>root</a> / <a onClick={(e) => e.preventDefault()}>{getCurrentFolderName()}</a></p>
                        </div>
                }
                <div className="video_thumbnails__alt"> {/* awesome__scroll_bar */}
                    <div className="row video_thumbnails_scroll  mb-0">
                        {renderVideos()}
                    </div>
                </div>
            </div>
        </LinkFile.globalModal>
    );
}

const mapStateToProps = state => {
    return {
        videoFolders: state.videoEmailReducer.videoFolders,
        videos: state.videoEmailReducer.videos,
        s3ServerVideoUrl: state.videoEmailReducer.s3ServerVideoUrl,
        videoLoader: state.videoEmailReducer.videoLoader,
        folderId: state.videoEmailReducer.folderId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getVideoFolders: () => dispatch(getVideoFolders()),
        getVideos: (params) => dispatch(getVideos(params)),
        deleteVideo: (params, callback) => dispatch(deleteVideo(params, callback)),
        updateFolderId: (params) => dispatch(updateFolderId(params)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoLibraryModal);